<script setup>
import { useAdminStore, useListStore } from "@/stores";
import { computed, onMounted } from "vue";
import roles from "@/config/lists/roles";
import userResponsibilities from "@/config/lists/userResponsibilities";

const adminStore = useAdminStore();
const listStore = useListStore();

const keyword = computed({
  get: () => adminStore.filters.keyword,
  set: (value) => (adminStore.filters.keyword = value),
});

const advanced = computed({
  get: () => adminStore.filters.advanced,
  set: (value) => (adminStore.filters.advanced = value),
});

const appliedFilters = computed(() => {
  const adv = advanced.value;
  return Object.values(adv).filter((val) => {
    if (val == null) return false; // null or undefined
    if (Array.isArray(val)) return val.length > 0; // empty array
    if (typeof val === "string") return val.trim() !== ""; // empty string
    return true; // all other non-null, non-empty values
  }).length;
});

const handleResetBtnClick = () => {
  adminStore.resetAction();
};

const hideSimpleSearch = computed(() => {
  return false;
});

const variant = "admin";

onMounted(async () => {});
</script>

<template>
  <div v-if="!hideSimpleSearch">
    <v-text-field v-model="keyword" name="searchbar" label="Search (by name)" />
  </div>
  <v-expansion-panels class="mb-5">
    <v-expansion-panel :class="`advanced-filters-panel panel-${variant}`">
      <v-expansion-panel-title :class="`title-${variant}`">
        <v-icon icon="mdi-filter" /> <b>Advanced Filters</b>
        <div class="ml-2 text-caption font-weight-bold">
          ({{ appliedFilters }}
          <span v-if="appliedFilters == 1">filter</span>
          <span v-else>filters</span> applied)
        </div>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <div class="d-flex ga-5 filter-row">
          <div class="flex-1-0-0">
            <v-date-input
              v-model="advanced.regDates"
              label="Registration Dates"
              variant="outlined"
              prepend-icon=""
              multiple="range"
              placeholder="DD/MM/YYYY"
              prepend-inner-icon="$calendar"
              clearable
            />
          </div>
          <div class="flex-1-0-0">
            <v-autocomplete
              v-model="advanced.roles"
              label="User roles"
              :items="roles"
              item-title="name"
              item-value="id"
              variant="outlined"
              clearable
              multiple
            />
          </div>
          <div class="flex-1-0-0">
            <v-autocomplete
              v-model="advanced.userResponsibilities"
              label="User responsibilities"
              :items="userResponsibilities"
              item-title="name"
              item-value="value"
              variant="outlined"
              clearable
              multiple
            />
          </div>
        </div>
        <div class="d-flex ga-5">
          <v-btn
            :color="variant"
            variant="outlined"
            @click="handleResetBtnClick"
          >
            Reset
          </v-btn>
        </div>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style scoped>
.filter-row {
  flex-wrap: wrap !important;
}

@media (max-width: 599px) {
  .filter-row > div {
    flex: 0 0 100% !important;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .filter-row > div {
    flex: 0 0 calc(50% - 10px) !important;
  }
}
</style>
